import { useState, useEffect } from 'react'

import './Header.css'
import logo from '../../assets/images/logo.svg'
import { Link, useLocation } from 'react-router-dom'

import ListHome from '../../component/ListHome'
import ListList from '../../component/ListList'

const Header = () => {

  const [show, setShow] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setShow(false)
    // console.log(location.pathname)
    window.scrollTo(0, 0)
  }, [location])

  const handleMenu = () => {
    setShow(pre => !pre);
  }



  return (
    <header>
      <div className="container">
        <Link to='/' className="logo">
          <img src={logo} loading='lazy' alt="logo" />
          <h1 className='l-name'>Homi</h1>
        </Link>
        <div className={show ? "burger active" : "burger"} onClick={handleMenu}>
          <span></span>
        </div>

        <nav className={show ? "show" : ""}>
          {location.pathname === '/' ?
            <ListHome handleMenu={handleMenu} />
            :
            <ListList handleMenu={handleMenu} />
          }
          <div className="contact">
            <a href='https://Rezkaudi.github.io/Portfolio'>Contact Us</a>
          </div>
        </nav>
      </div>
    </header>

  )
}

export default Header